import type {DetectedMeeting} from '../../../../store/features/calls/callsService';
import type {IcsStart} from './ics';

export const DEFAULT_MEETING_MINUTES = 30;

export const meetingStart = (meeting: DetectedMeeting): IcsStart => {
    if (meeting.startsAt) {
        const utc = new Date(meeting.startsAt);
        if (!Number.isNaN(utc.getTime())) return {kind: 'datetime', utc};
    }
    return {kind: 'date', date: meeting.date};
};

export const knownTimeZone = (zone: string | null | undefined): string | undefined => {
    if (!zone) return undefined;
    try {
        new Intl.DateTimeFormat('en-GB', {timeZone: zone});
        return zone;
    } catch {
        return undefined;
    }
};

export const formatMeetingDate = (start: IcsStart, timeZone?: string | null, locale = 'en-GB'): string => {
    if (start.kind === 'datetime') {
        return new Intl.DateTimeFormat(locale, {weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: knownTimeZone(timeZone)})
            .format(start.utc);
    }
    const [year, month, day] = start.date.split('-').map(Number);
    return new Intl.DateTimeFormat(locale, {weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC'})
        .format(new Date(Date.UTC(year, month - 1, day)));
};

export const formatMeetingTime = (start: IcsStart, timeZone?: string | null, locale = 'en-GB'): string | null =>
    start.kind === 'datetime'
        ? new Intl.DateTimeFormat(locale, {hour: '2-digit', minute: '2-digit', timeZone: knownTimeZone(timeZone), timeZoneName: 'short'}).format(start.utc)
        : null;
